<style>
.c-cart table thead th, .c-cart table tbody td {
    border-bottom: 1px solid #ddd;
    padding: 10px;
}

.c-cart table tfoot td {
    padding: 10px;
}

</style>

<template>
    <div class="c-cart">
        <table :class="{ 'table-responsive': Core.Display.isMobile() }"  width="100%">
            <tbody>
                <template v-if="!Core.Display.isMobile()">
                    <tr v-for="product, productIndex in dataProducts">
                        <td width="5%">
                            <b-button v-if="readOnly===false" @click="onTrashClick(product, productIndex)" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></b-button>
                        </td>
                        <td width="5%"><img width="50px" :src="Core.Product.displayImage(product.image)" /></td>
                        <td width="70%">
                            <strong>{{product.title}}</strong><br/>
                            <small v-if="product.type === Core.Product.typeRecurringSubscription" class="mt-3">{{displayRecurringPaymentSpecs(product)}}</small>
                            <p>{{product.shortDescription}}</p>
                            <label v-if="readOnly===true">{{dataProducts[productIndex].quantity}}</label>
                            <InputQuantity :ref="'inputQuantity' + productIndex" @onPlus="onPlus(productIndex)" @onMinus="onMinus(productIndex)"  @change="eval" class="mt-3" v-if="readOnly===false" v-model="dataProducts[productIndex].quantity"></InputQuantity>
                        </td>
                        <td class="text-right" width="10%">
                            {{Core.Currency.format(product.regularPrice)}}
                            <div class="text-right" v-if="dataProducts[productIndex].data !== undefined&&dataProducts[productIndex].data.promoCode !== undefined&&dataProducts[productIndex].data.promoCode.code!==undefined">
                                <br/>
                                <b><i>{{dataProducts[productIndex].data.promoCode.code}}</i></b>&nbsp;<i>-{{Core.Currency.format(dataProducts[productIndex].data.promoCode.deductible)}}</i>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="dataProducts.length === 0">
                        <td colspan="4">
                            <b-alert show variant="light">
                                {{Core.Definition.getDefinition('Votre panier est vide')}}
                            </b-alert>
                        </td>
                    </tr>
                </template>
                <template v-if="Core.Display.isMobile()">
                    <tr v-for="product, productIndex in dataProducts">
                        <td width="5%">
                            <b-button v-if="readOnly===false" @click="onTrashClick(product, productIndex)" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></b-button>
                        </td>
                        <td width="5%"></td>
                        <td width="70%">
                            <img width="50px" class="p-2" :src="Core.Product.displayImage(product.image)" /><br/>
                            <strong>{{product.title}}</strong><br/>
                            <small v-if="product.type === Core.Product.typeRecurringSubscription" class="mt-3">{{displayRecurringPaymentSpecs(product)}}</small>
                            <p>{{product.shortDescription}}</p>
                            <label v-if="readOnly===true">{{dataProducts[productIndex].quantity}}</label>
                            <InputQuantity :ref="'inputQuantity' + productIndex" @onPlus="onPlus(productIndex)" @onMinus="onMinus(productIndex)"  @change="eval" class="mt-3" v-if="readOnly===false" v-model="dataProducts[productIndex].quantity"></InputQuantity>

                            <div class="pb-2">
                                <label>{{Core.Currency.format(product.regularPrice)}}</label>
                                <div class="text-right" v-if="dataProducts[productIndex].data !== undefined&&dataProducts[productIndex].data.promoCode !== undefined&&dataProducts[productIndex].data.promoCode.code!==undefined">
                                    <br/>
                                    <b><i>{{dataProducts[productIndex].data.promoCode.code}}</i></b>&nbsp;<i>-{{Core.Currency.format(dataProducts[productIndex].data.promoCode.deductible)}}</i>
                                </div>
                            </div>

                        </td>
                        <td class="text-right" width="10%">
                        </td>
                    </tr>
                </template>

            </tbody>
            <tfoot>
                <tr v-if="Core.Session.AuthUser.isAuth()">
                    <td colspan="2"></td>
                    <td colspan="2">
                        <div class="pull-right">
                            <InputPromoCode
                                style="width:200px"
                                ref="promoCode"
                                v-model="dataPromoCode"
                                :placeHolder="Core.Definition.getDefinition('Code promo')"
                                root="/promo-code/validate">
                                </InputPromoCode>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2"></td>
                    <td class="text-right">
                        {{Core.Definition.getDefinition('Sous-total')}}
                    </td>
                    <td class="text-right">{{Core.Currency.format(dataSubTotal)}}</td>
                </tr>
                <tr v-for="tax in dataTaxes">
                    <td colspan="2"></td>
                    <td class="text-right">
                        <b>{{tax.label}}</b>
                    </td>
                    <td class="text-right">
                        {{Core.Currency.format(tax.total)}}
                    </td>
                </tr>
                <tr>
                    <td colspan="2"></td>
                    <td class="text-right">
                        {{Core.Definition.getDefinition('Total')}}
                    </td>
                    <td class="text-right"> {{Core.Currency.format(dataTotal)}}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
    import InputQuantity from './InputQuantity'
    import InputText from './InputText';
    import InputPromoCode from './InputPromoCode';
    export default {
        name: 'Cart',
        components: {
            InputText,
            InputQuantity,
            InputPromoCode
        },
        props: {
            value: {
                type: Array,
                default: function () {
                    return []
                }
            },
            readOnly: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            value(val) {
                this.dataProducts = val
                this.eval()
            },
            dataPromoCode: {
                handler(val) {

                    this.eval()
                }
            }
        },
        computed: {
            total: {
                get() {
                    return this.dataTotal
                }
            },
            subTotal: {
                get() {
                    return this.dataSubTotal
                }
            }
        },
        mounted() {
            this.dataProducts = this.value
            this.eval()
        },
        data: () => {
            return {
                Core: window.Core,
                dataProducts: [],
                dataSubTotal: 0,
                dataTotal: 0,
                dataTaxes: [],
                dataPromoCode: {}
            }
        },
        methods: {
            onPlus(productIndex) {
                let quantity = this.$refs['inputQuantity' + productIndex][0].dataValue
                this.dataProducts[productIndex].quantity = quantity
                this.$emit('onAddToCartClick', this.dataProducts[productIndex])
            },
            onMinus(productIndex) {
                let quantity = this.$refs['inputQuantity' + productIndex][0].dataValue
                this.dataProducts[productIndex].quantity = quantity
                this.$emit('onAddToCartClick', this.dataProducts[productIndex])
            },
            onTrashClick(product, productIndex) {
                this.dataProducts.splice(productIndex, 1)
                Core.Cart.remove(product.id)
                this.$emit('onTrashClick', product, productIndex)
            },
            displayRecurringPaymentSpecs(product) {
                if (product.type === Core.Product.typeRecurringSubscription) {
                    return Core.Text.format(Core.Definition.getDefinition('{0} {1} {2} durant {3} {2}'), Core.Currency.format(product.regularPrice), Core.Select.label(product.periodPaymentInterval, Core.Product.periodIntervalOptions()), Core.Select.label(product.periodPayment, Core.Product.periodOptions()), product.periodPaymentLength)
                }
                return ''
            },
            eval() {

                this.dataSubTotal = 0
                this.dataTotal = 0

                let taxes = Core.Session.Setting.getTaxes()
                this.dataTaxes = taxes
                for(let taxIndex in this.dataTaxes) {
                    this.dataTaxes[taxIndex].total = 0
                }

                for(let productIndex in this.dataProducts) {

                    if (this.dataProducts[productIndex].regularPrice !== undefined) {
                        if (this.dataProducts[productIndex].quantity!==undefined) {

                            if (this.dataProducts[productIndex].taxes === undefined) {
                                this.dataProducts[productIndex].taxes = taxes
                            }

                            let subTotal = 0
                            subTotal = (this.dataProducts[productIndex].regularPrice * this.dataProducts[productIndex].quantity)

                            let deductible = Core.PromoCode.getDeductible(this.dataPromoCode, this.dataProducts[productIndex].id, subTotal)
                            if (deductible!==false) {
                                if(this.dataProducts[productIndex].data === undefined) {
                                    this.dataProducts[productIndex].data = {
                                        promoCode:{}
                                    }
                                }
                                let promoCode = {
                                    code: this.dataPromoCode.code,
                                    id: this.dataPromoCode.instance.id,
                                    deductible: deductible
                                }

                                this.dataProducts[productIndex].data.promoCode = promoCode
                                Core.Cart.addPromoCode(this.dataProducts[productIndex].id, promoCode)
                            }
                            if (this.dataProducts[productIndex].data !== undefined && this.dataProducts[productIndex].data.promoCode !==undefined&&this.dataProducts[productIndex].data.promoCode.deductible !==undefined) {
                                subTotal -= this.dataProducts[productIndex].data.promoCode.deductible
                            }

                            let productTaxesTotal = 0
                            if (this.dataProducts[productIndex].isTaxable!==undefined&&this.dataProducts[productIndex].isTaxable == true) {
                                if (taxes) {
                                    for(let taxIndex in taxes) {
                                        let tax = taxes[taxIndex]
                                        productTaxesTotal += Core.Taxes.total(subTotal, tax)
                                        if (undefined === this.dataTaxes[taxIndex].total) {
                                            this.dataTaxes[taxIndex].total = 0
                                        }
                                        this.dataTaxes[taxIndex].total += Core.Taxes.total(subTotal, tax)
                                    }
                                }
                            }
                            this.dataProducts[productIndex].taxesTotal = productTaxesTotal

                            let total = subTotal + productTaxesTotal

                            this.dataProducts[productIndex].total = subTotal
                            this.dataSubTotal += subTotal
                            this.dataTotal += total
                        }
                    }
                }
            }
        }
    }
</script>
